/**
 * SimpleHeader Component
 * 
 * Professional header for authentication pages (Login, ForgotPassword, etc.)
 * Displays only the logo without user profile information
 * Features:
 * - Matches the dashboard header design
 * - Blue gradient background
 * - Responsive logo sizing
 * - Clean, professional appearance
 * 
 * Usage:
 * import SimpleHeader from './SimpleHeader';
 * <SimpleHeader onLogoClick={() => navigate('/')} />
 * 
 * @component
 * @param {Object} props
 * @param {Function} props.onLogoClick - Callback when logo is clicked
 * @returns {React.ReactElement} Header with logo only
 */
import React, { useState } from "react";
import logo from "./logo.png";

const SimpleHeader = ({ onLogoClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header 
      className={`bg-gray-900 backdrop-blur-md shadow-xl sticky top-0 z-50 w-full border-b ${
        isScrolled 
          ? "border-gray-800/70 shadow-lg" 
          : "border-gray-800/40"
      } transition-all duration-500`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-start">
        {/* Logo */}
        <button
          onClick={onLogoClick}
          className="focus:outline-none group flex items-center"
          aria-label="Go to Home"
        >
          <img
            src={logo}
            alt="GCRD Logo"
            className="h-7 w-auto sm:h-8 lg:h-9 transition-all duration-300 group-hover:scale-110 drop-shadow-lg filter"
          />
        </button>
      </div>
    </header>
  );
};

export default SimpleHeader;
